import React, { useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { useAuth } from '../../context/AuthContext';
import './PlanCreateModal.css';

const { Option } = Select;
const { TextArea } = Input;

function PlanCreateModal({ visible, onClose, onSubmit, teamId }) {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const { orgData } = useAuth();

	const handleSubmit = async (values) => {
		try {
			if (!orgData?.id) {
				throw new Error('Organization ID is required');
			}

			setLoading(true);
			const planData = {
				...values,
				teamId: teamId,
				organizationId: orgData.id,
			};

			await onSubmit(planData);
			form.resetFields();
			onClose();
			message.success('Plan created successfully');
		} catch (error) {
			console.error('Submit error:', error);
			message.error(error.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title='Create Plan'
			open={visible}
			onCancel={() => {
				form.resetFields();
				onClose();
			}}
			okText='Create'
			confirmLoading={loading}
			onOk={() => form.submit()}
			className='common-modal plan-modal'>
			<Form
				form={form}
				layout='vertical'
				onFinish={handleSubmit}
				initialValues={{
					visibility: 'private',
					status: 'draft',
				}}>
				<Form.Item
					name='mainTitle'
					label='Title'
					rules={[
						{ required: true, message: 'Please enter a title' },
						{
							max: 256,
							message: 'Title must be less than 256 characters',
						},
					]}>
					<Input placeholder='Enter plan title' />
				</Form.Item>

				<Form.Item
					name='description'
					label='Description'>
					<TextArea
						rows={4}
						placeholder='Enter plan description'
					/>
				</Form.Item>

				<Form.Item
					name='estimatedDuration'
					label='Estimated Duration (minutes)'
					rules={[
						{
							type: 'number',
							transform: (value) => parseInt(value) || null,
						},
						{
							min: 1,
							message: 'Duration must be at least 1 minute',
						},
					]}>
					<Input
						type='number'
						placeholder='Enter duration in minutes'
					/>
				</Form.Item>

				<Form.Item
					name='visibility'
					label='Visibility'
					rules={[
						{ required: true, message: 'Please select visibility' },
					]}>
					<Select placeholder='Select visibility'>
						<Option value='hidden'>Hidden</Option>
						<Option value='private'>Private</Option>
						<Option value='public'>Public</Option>
					</Select>
				</Form.Item>

				<Form.Item
					name='status'
					label='Status'
					rules={[
						{ required: true, message: 'Please select status' },
					]}>
					<Select placeholder='Select status'>
						<Option value='draft'>Draft</Option>
						<Option value='published'>Published</Option>
						<Option value='archived'>Archived</Option>
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
}

export default PlanCreateModal;
